import axios from "axios";
import React, { useEffect, useState } from "react";

import SuggestedCategory from "./SugesstedCategory";

import CategoryContentMap from "./CategoryContentMap";
import ContentLoader from "../../../../../../Screen/ContentLoader";
import SubCateHeader from "../../../../../../Screen/Category/SubCateHeader";

const CategoryView = (props) => {
  const [subCategory, setSubCategory] = useState([]);
  const [categoryName, setCategoryName] = useState("");

  const [loading, setLoading] = useState(true);

  const headerStyle = {
    BorderStyle: {
      borderRadius: "5px",
    },
  };

  useEffect(() => {
    const cat_slug = props.match.params.slug;

    axios.get(`/api/subcategory/${cat_slug}`).then((res) => {
      if (res.data.status === 200) {
        setSubCategory(res.data.subcategory);
        setCategoryName(res.data.category);
        setLoading(false);
      }
    });
  }, [props.match.params.slug]);

  return (
    <>
      {loading ? (
        <ContentLoader />
      ) : (
        <div className="postTab">
          <SubCateHeader name={categoryName.name} link={"/category"} />

          <div className="row">
            {subCategory.map((singleData) => {
              return (
                <CategoryContentMap
                  singleData={singleData}
                  key={singleData.id}
                />
              );
            })}
          </div>
          <SuggestedCategory headerStyle={headerStyle} />
        </div>
      )}
    </>
  );
};

export default CategoryView;
